
import { defineComponent, ref, onMounted } from 'vue';

interface ImageObject {
  url: string;
  width: number;
  height: number;
}

// @ts-expect-error context is only a webpack method
const images = require.context('../assets/', true, /\.jpg|.svg|.png$/);
const imageList: string[] = images.keys().map((image: string) => images(image));

export default defineComponent({
  name: 'DevLayoutIcons',
  setup() {
    const parsedImg = ref<ImageObject[]>([]);

    onMounted(() => {
      imageList.forEach((image: string) => {
        const img = new Image();
        img.onload = () => {
          parsedImg.value.push({
            url: image,
            width: img.width,
            height: img.height,
          });
        };
        img.src = image;
      });
    });

    return {
      parsedImg,
    };
  },
});
